// import { useMediaQuery } from "@rshbintech.dboul/core-ui";
import { CloseIcon } from "../../../../packages/icons";
import { CircleButton } from "../../../../packages/components";
import styles from "./file-icon.module.scss";

type Props = {
  onClick: () => void;
};

export const RemoveIconComponent = ({ onClick }: Readonly<Props>) => (
  // const isMobile = useMediaQuery("mobile");

  <CircleButton
    onClick={onClick}
    className={styles.remove}
    size="small"
    dataTestId="file-remove-button"
  >
    <CloseIcon size="medium" />
  </CircleButton>
);
